import {useBooleanFeatureFlag} from "ub-feature-flagging-react";

import {isFeatureEnabled} from "shared/Utils/FeatureUtils";
import {SHOW_FOR_YOU_TAB} from "shared/constants";

import {UniversityField} from "../../../../types/generated";
import {useRecommendations} from "../../Recommendations/RecommendationsProvider/RecommendationsProvider";
import {useUser} from "../../User/useUser";

export const useNavigationMap = (university: UniversityField) => {
    const user = useUser();
    const {hasRecommendations} = useRecommendations();

    const forYouTabEnabled = useBooleanFeatureFlag(SHOW_FOR_YOU_TAB.key, SHOW_FOR_YOU_TAB.value);
    const hasStaffProfilesEnabled = isFeatureEnabled("staffProfiles", university);
    const isBlogsEnabled = isFeatureEnabled("userGeneratedContent", university);

    return {
        showStudents: true,
        showStaff: hasStaffProfilesEnabled,
        showRecommendations: forYouTabEnabled && hasRecommendations && user !== undefined,
        showContent: isBlogsEnabled,
        showInbox: true,
        showSettings: user !== undefined,
        showSignup: user === undefined,
        showLogin: user === undefined,
    };
};
